export interface RouteType {
	module_code: string;
	path: string;
	title: string;
	permission: string[];
	main_module_code?: string;
}

export interface SubRouteType extends RouteType {
	main_module_code: string;
}

export interface MainRouteType extends RouteType {
	fontIcon: string;
	icon: string;
	subMenu: SubRouteType[];
}

export const mainRoutesConfig: MainRouteType[] = [
	{
		module_code: "PRODUCT",
		path: "/products",
		title: "",
		fontIcon: "bi-bag-heart-fill",
		icon: "bi bi-bag-heart-fill",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "EMPLOYEE",
		path: "/employee",
		title: "",
		fontIcon: "bi-bag-heart-fill",
		icon: "bi bi-bag-heart-fill",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "INVENTORY",
		path: "/inventory",
		title: "",
		fontIcon: "bi-box-seam",
		icon: "bi bi-box-seam",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "SETTING",
		path: "/setting",
		title: "",
		fontIcon: "bi-gear",
		icon: "bi bi-gear",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "MEMBER_MANAGEMENT",
		path: "/member",
		title: "",
		fontIcon: "bi-people",
		icon: "bi bi-people",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "SALE",
		path: "/sale",
		title: "",
		fontIcon: "bi-receipt",
		icon: "bi bi-receipt",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "BRANCH",
		path: "/branch",
		title: "",
		fontIcon: "bi-building",
		icon: "bi bi-building",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "HOLIDAY",
		path: "/holiday",
		title: "จัดการวันหยุด",
		fontIcon: "bi-calendar-check",
		icon: "bi bi-calendar-check",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "TEST",
		path: "/test",
		title: "",
		fontIcon: "bi-receipt",
		icon: "bi bi-receipt",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "LOG",
		path: "/log",
		title: "",
		fontIcon: "bi-journal-text",
		icon: "bi bi-journal-text",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "REPORT",
		path: "/report",
		title: "",
		fontIcon: "bi-file-earmark-text",
		icon: "bi bi-file-earmark-text",
		subMenu: [],
		permission: [],
	},
	{
		module_code: "WORK_SCHEDULE",
		path: "/work-schedule",
		title: "",
		fontIcon: "bi-calendar3",
		icon: "bi bi-calendar3",
		subMenu: [],
		permission: [],
	},
];

export const subRoutesConfig: SubRouteType[] = [
	{
		module_code: "APPROVAL_REQUEST",
		main_module_code: "LOG",
		path: "/log/approval-requests",
		title: "คำขออนุญาต",
		permission: [],
	},
	{
		module_code: "ROLE_MANAGEMENT",
		main_module_code: "SETTING",
		path: "/setting/role_management",
		title: "",
		permission: [],
	},
	{
		module_code: "MODULE_MANAGEMENT",
		main_module_code: "SETTING",
		path: "/setting/module_management",
		title: "",
		permission: [],
	},
	{
		module_code: "USER_MANAGEMENT",
		main_module_code: "SETTING",
		path: "/setting/user_management",
		title: "",
		permission: [],
	},
	{
		module_code: "PRODUCT_CAT",
		main_module_code: "PRODUCT",
		path: "/products/categories",
		title: "",
		permission: [],
	},
	{
		module_code: "PRODUCTS",
		main_module_code: "PRODUCT",
		path: "/products/list",
		title: "",
		permission: [],
	},
	{
		module_code: "TAG",
		main_module_code: "PRODUCT",
		path: "/products/tags",
		title: "แท็กสินค้า",
		permission: [],
	},
	{
		module_code: "MASTER_ORDER",
		main_module_code: "INVENTORY",
		path: "/inventory/master_orders",
		title: "Master Order",
		permission: [],
	},
	{
		module_code: "TRANSFER_ORDER",
		main_module_code: "INVENTORY",
		path: "/inventory/transfer_orders",
		title: "Transfer สินค้า",
		permission: [],
	},
	{
		module_code: "WRITE_OFF",
		main_module_code: "INVENTORY",
		path: "/inventory/write_offs",
		title: "Write Off สต็อก",
		permission: [],
	},
	{
		module_code: "PRODUCT_INVENTORY",
		main_module_code: "INVENTORY",
		path: "/inventory/product_inventory",
		title: "",
		permission: [],
	},
	{
		module_code: "COST_MANAGE",
		main_module_code: "INVENTORY",
		path: "/inventory/cost_management",
		title: "",
		permission: [],
	},
	{
		module_code: "EMPLOYEE_POS",
		main_module_code: "EMPLOYEE",
		path: "/employee/position",
		title: "",
		permission: [],
	},
	{
		module_code: "EMPLOYEES",
		main_module_code: "EMPLOYEE",
		path: "/employee/list",
		title: "",
		permission: [],
	},
	{
		module_code: "ATTENDANCE",
		main_module_code: "EMPLOYEE",
		path: "/employee/attendance",
		title: "",
		permission: [],
	},
	{
		module_code: "ATTENDANCE_REPORT",
		main_module_code: "EMPLOYEE",
		path: "/employee/attendance-report",
		title: "",
		permission: [],
	},
	{
		module_code: "LEAVE_SETTINGS",
		main_module_code: "EMPLOYEE",
		path: "/employee/leave",
		title: "ตั้งค่าการลา",
		permission: [],
	},
	{
		module_code: "LEAVE_MANAGEMENT",
		main_module_code: "EMPLOYEE",
		path: "/employee/leave-management",
		title: "จัดการการลา",
		permission: [],
	},
	{
		module_code: "P_MODULE_MANAGEMENT",
		main_module_code: "SETTING",
		path: "/setting/pos_modules",
		title: "",
		permission: [],
	},
	{
		module_code: "MEMBER_LIST",
		main_module_code: "MEMBER_MANAGEMENT",
		path: "/member/list",
		title: "",
		permission: [],
	},
	{
		module_code: "MEMBER_TIER",
		main_module_code: "MEMBER_MANAGEMENT",
		path: "/member/tier",
		title: "",
		permission: [],
	},
	{
		module_code: "MEMBER_POINT",
		main_module_code: "MEMBER_MANAGEMENT",
		path: "/member/point",
		title: "",
		permission: [],
	},
	{
		module_code: "SALE_LIST",
		main_module_code: "SALE",
		path: "/sale/list",
		title: "",
		permission: [],
	},
	{
		module_code: "POINT_SETTING",
		main_module_code: "SETTING",
		path: "/setting/point_setting",
		title: "",
		permission: [],
	},
	{
		module_code: "RECEIPT_FORMAT",
		main_module_code: "SETTING",
		path: "/setting/receipt_format",
		title: "",
		permission: [],
	},
	{
		module_code: "PAYMENT_CHANNEL",
		main_module_code: "SETTING",
		path: "/setting/payment_channel",
		title: "",
		permission: [],
	},
	{
		module_code: "ROUNDING_CONFIG",
		main_module_code: "SETTING",
		path: "/setting/rounding_config",
		title: "",
		permission: [],
	},
	{
		module_code: "POS_VERSION_SETTING",
		main_module_code: "SETTING",
		path: "/setting/pos_version",
		title: "",
		permission: [],
	},
	{
		module_code: "DEVICE_MANAGE",
		main_module_code: "SETTING",
		path: "/setting/pos_device",
		title: "",
		permission: [],
	},
	{
		module_code: "LEGACY_SYNC",
		main_module_code: "SETTING",
		path: "/setting/migration",
		title: "ดึงข้อมูลยอดขาย Legacy",
		permission: [],
	},
	{
		module_code: "BRANCH_MANAGE",
		main_module_code: "BRANCH",
		path: "/branch/management",
		title: "",
		permission: [],
	},
	{
		module_code: "CASH_MANAGE",
		main_module_code: "BRANCH",
		path: "/branch/cash_management",
		title: "จัดการเงินสด",
		permission: [],
	},
	{
		module_code: "HOLIDAY_MANAGE",
		main_module_code: "HOLIDAY",
		path: "/holiday/management",
		title: "จัดการวันหยุด",
		permission: [],
	},
	{
		module_code: "SUB TEST",
		main_module_code: "TEST",
		path: "/test/test",
		title: "",
		permission: [],
	},
	{
		module_code: "PROMOTION_LIST",
		main_module_code: "SALE",
		path: "/sale/promotion",
		title: "",
		permission: [],
	},
	{
		module_code: "CONTENT_MANAGEMENT",
		main_module_code: "SALE",
		path: "/sale/content",
		title: "",
		permission: [],
	},
	{
		module_code: "SALE_RETURN",
		main_module_code: "SALE",
		path: "/sale/returns",
		title: "",
		permission: [],
	},
	{
		module_code: "SALE_CANCELLATION",
		main_module_code: "SALE",
		path: "/sale/cancellations",
		title: "",
		permission: [],
	},
	{
		module_code: "SALES_TARGET",
		main_module_code: "SALE",
		path: "/sale/targets",
		title: "ตั้งเป้ายอดขาย",
		permission: [],
	},
	{
		module_code: "TAX_INVOICE",
		main_module_code: "SALE",
		path: "/sale/tax-invoices",
		title: "ใบกำกับภาษีเต็มรูปแบบ",
		permission: [],
	},
	{
		module_code: "TAX_CUSTOMER",
		main_module_code: "SALE",
		path: "/sale/tax-customers",
		title: "ข้อมูลผู้เสียภาษี",
		permission: [],
	},
	{
		module_code: "CYCLE_COUNT",
		main_module_code: "INVENTORY",
		path: "/inventory/cycle_counts",
		title: "ใบนับสต็อก",
		permission: [],
	},
	{
		module_code: "STOCK_ADJUST",
		main_module_code: "INVENTORY",
		path: "/inventory/stock_adjustments",
		title: "ปรับสต็อก",
		permission: [],
	},
	{
		module_code: "WMS_RETURN",
		main_module_code: "INVENTORY",
		path: "/inventory/wms_returns",
		title: "ส่งคืนสินค้าไป WMS",
		permission: [],
	},
	{
		module_code: "REPORT_SALE",
		main_module_code: "REPORT",
		path: "/report/sale/overtime",
		title: "ยอดขายตามช่วงเวลา",
		permission: [],
	},
	{
		module_code: "REPORT_SALE_PRODUCT",
		main_module_code: "REPORT",
		path: "/report/sale/product",
		title: "ยอดขายตามสินค้า",
		permission: [],
	},
	{
		module_code: "REPORT_SALE_CATEGORY",
		main_module_code: "REPORT",
		path: "/report/sale/category",
		title: "ยอดขายตามประเภทสินค้า",
		permission: [],
	},
	{
		module_code: "REPORT_SALE_PAYMENT",
		main_module_code: "REPORT",
		path: "/report/sale/payment",
		title: "ยอดขายตามวิธีการชำระเงิน",
		permission: [],
	},
	{
		module_code: "REPORT_SALE_SHIFT",
		main_module_code: "REPORT",
		path: "/report/sale/shift",
		title: "ยอดขายตามกะทำงาน",
		permission: [],
	},
	{
		module_code: "REPORT_SALE_EMPLOYEE",
		main_module_code: "REPORT",
		path: "/report/sale/employee",
		title: "ยอดขายตามพนักงาน",
		permission: [],
	},
	{
		module_code: "REPORT_PROMOTION",
		main_module_code: "REPORT",
		path: "/report/sale/promotion",
		title: "การใช้โปรโมชั่น",
		permission: [],
	},
	{
		module_code: "REPORT_SALE_TAX",
		main_module_code: "REPORT",
		path: "/report/sale/tax",
		title: "รายงานภาษี",
		permission: [],
	},
	{
		module_code: "REPORT_VOID",
		main_module_code: "REPORT",
		path: "/report/sale/void-cancelled",
		title: "บิลที่ถูกยกเลิก (Void)",
		permission: [],
	},
	{
		module_code: "REPORT_SALE_TARGET",
		main_module_code: "REPORT",
		path: "/report/sale/target-comparison",
		title: "เปรียบเทียบเป้าหมายยอดขาย",
		permission: [],
	},
	{
		module_code: "REPORT_MOVEMENT",
		main_module_code: "REPORT",
		path: "/report/stock-movement",
		title: "รายงานความเคลื่อนไหวสินค้า",
		permission: [],
	},
	{
		module_code: "WORK_SCHEDULE_MANAGE",
		main_module_code: "WORK_SCHEDULE",
		path: "/work-schedule/calendar",
		title: "ตารางเวลาทำงาน",
		permission: [],
	},
	{
		module_code: "SHIFT_MANAGE",
		main_module_code: "WORK_SCHEDULE",
		path: "/work-schedule/shift-templates",
		title: "จัดการแม่แบบกะทำงาน",
		permission: [],
	},
];
